import _ from 'lodash';
import { InputFieldConfig } from 'src/@vymo/ui/molecules/form/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Keys, locale } from 'src/i18n';
import { UPLOAD_FORM } from 'src/modules/constants';
import { getState } from 'src/store';
import axios from 'src/workspace/axios';
import { removeDialog, renderModule } from 'src/workspace/slice';
import { parseJSON } from 'src/workspace/utils';
import { BULK_UPLOAD } from '../ddp/constants';
import { getRevyreState } from '../selectors';
import { setIsDialogOpen } from '../slice';
import {
  BASE_URL,
  fetchEntityList,
  fetchModuleConfig,
  getRequestHeaders,
  syncWorkflowConfigToSlice,
} from '../thunk';

const onUpdate = async ({ dispatch, props }) => {
  const { domainType, workflowType, activityType, actionType } = props;
  if (actionType !== BULK_UPLOAD) {
    await dispatch(fetchModuleConfig({ domainType, workflowType }));
  }

  if (activityType) {
    dispatch(fetchEntityList({ domainType, payload: {} }));
  }
  dispatch(setIsDialogOpen(true));
};

const onDeactivate = ({ dispatch }) => {
  dispatch(setIsDialogOpen(false));
};

const onActivate = ({ dispatch }) => {
  const modulesConfig = getRevyreState(getState()).modules;
  if (_.isEmpty(modulesConfig)) {
    syncWorkflowConfigToSlice(dispatch);
  }
};

export const uploadFormSubmit = createAsyncThunk(
  'revyre/uploadFormSubmit',
  async (
    {
      inputFields,
      actionType,
    }: {
      inputFields: InputFieldConfig[];
      actionType: string;
    },
    { dispatch },
  ) => {
    try {
      switch (actionType) {
        case BULK_UPLOAD: {
          const documentID = parseJSON(inputFields?.[0]?.value)?.items?.[0]?.id;
          const payload = {
            documentID,
          };

          const response = await axios.post(
            `${BASE_URL}/bulk-allocation`,
            payload,
            {
              headers: getRequestHeaders(),
            },
          );

          const { jobId } = response?.data?.payload || {};

          dispatch(
            renderModule({
              id: 'DDP_DETAILS',
              props: { jobId, actionType },
            }),
          );

          dispatch(removeDialog({ id: UPLOAD_FORM }));
          break;
        }
        default:
          return false;
      }

      return true;
    } catch (error) {
      return Promise.reject(locale(Keys.SOMETHING_WENT_WRONG));
    }
  },
);

export default { onUpdate, onDeactivate, onActivate };
